import VerificationCode from './VerificationCode';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { quickSubPage } from 'decorators/subPage';
import {
  verifyQuickVerificationCode,
  sendQuickVerificationCode,
} from 'actions/quickSubs';

const mapDispatchToProps = {
  verifyVerificationCode: verifyQuickVerificationCode,
  sendVerificationCode: sendQuickVerificationCode,
};

export default compose(
  quickSubPage,
  connect(null, mapDispatchToProps),
)(VerificationCode);
